import { useMemo } from "react";
import { useLocation } from "react-router-dom";

/**
 * Marketing pages share the public NavBar layout (logo + left-aligned links).
 * Kept in sync with the isMarketingPage logic in App.tsx via isMarketingPath.
 */
const EXACT = new Set(["/", "/about", "/privacy", "/terms", "/disclosures", "/blog", "/tarifs", "/integrations", "/affiliation", "/help", "/comparateur"]);
const PREFIXES = ["/blog/", "/fonctionnalites/", "/solutions/", "/vs/"];
const ALSO = new Set([
  "/journal-de-trading",
  "/meilleur-journal-de-trading",
  "/alternatives-journal-de-trading",
]);

export function isMarketingPath(pathname: string): boolean {
  if (EXACT.has(pathname) || ALSO.has(pathname)) return true;
  return PREFIXES.some((p) => pathname.startsWith(p));
}

export const useIsMarketingPage = () => {
  const location = useLocation();
  return useMemo(() => isMarketingPath(location.pathname), [location]);
};
